var map = {
	"./locale-provider/ar_EG.tsx": "./components/locale-provider/ar_EG.tsx",
	"./locale-provider/bg_BG.tsx": "./components/locale-provider/bg_BG.tsx",
	"./locale-provider/ca_ES.tsx": "./components/locale-provider/ca_ES.tsx",
	"./locale-provider/cs_CZ.tsx": "./components/locale-provider/cs_CZ.tsx",
	"./locale-provider/da_DK.tsx": "./components/locale-provider/da_DK.tsx",
	"./locale-provider/de_DE.tsx": "./components/locale-provider/de_DE.tsx",
	"./locale-provider/el_GR.tsx": "./components/locale-provider/el_GR.tsx",
	"./locale-provider/en_GB.tsx": "./components/locale-provider/en_GB.tsx",
	"./locale-provider/en_US.tsx": "./components/locale-provider/en_US.tsx",
	"./locale-provider/es_ES.tsx": "./components/locale-provider/es_ES.tsx",
	"./locale-provider/et_EE.tsx": "./components/locale-provider/et_EE.tsx",
	"./locale-provider/fa_IR.tsx": "./components/locale-provider/fa_IR.tsx",
	"./locale-provider/fi_FI.tsx": "./components/locale-provider/fi_FI.tsx",
	"./locale-provider/fr_BE.tsx": "./components/locale-provider/fr_BE.tsx",
	"./locale-provider/fr_FR.tsx": "./components/locale-provider/fr_FR.tsx",
	"./locale-provider/he_IL.tsx": "./components/locale-provider/he_IL.tsx",
	"./locale-provider/hu_HU.tsx": "./components/locale-provider/hu_HU.tsx",
	"./locale-provider/id_ID.tsx": "./components/locale-provider/id_ID.tsx",
	"./locale-provider/is_IS.tsx": "./components/locale-provider/is_IS.tsx",
	"./locale-provider/it_IT.tsx": "./components/locale-provider/it_IT.tsx",
	"./locale-provider/ja_JP.tsx": "./components/locale-provider/ja_JP.tsx",
	"./locale-provider/ko_KR.tsx": "./components/locale-provider/ko_KR.tsx",
	"./locale-provider/ku_IQ.tsx": "./components/locale-provider/ku_IQ.tsx",
	"./locale-provider/mn_MN.tsx": "./components/locale-provider/mn_MN.tsx",
	"./locale-provider/nb_NO.tsx": "./components/locale-provider/nb_NO.tsx",
	"./locale-provider/nl_BE.tsx": "./components/locale-provider/nl_BE.tsx",
	"./locale-provider/nl_NL.tsx": "./components/locale-provider/nl_NL.tsx",
	"./locale-provider/pl_PL.tsx": "./components/locale-provider/pl_PL.tsx",
	"./locale-provider/pt_BR.tsx": "./components/locale-provider/pt_BR.tsx",
	"./locale-provider/pt_PT.tsx": "./components/locale-provider/pt_PT.tsx",
	"./locale-provider/ru_RU.tsx": "./components/locale-provider/ru_RU.tsx",
	"./locale-provider/sk_SK.tsx": "./components/locale-provider/sk_SK.tsx",
	"./locale-provider/sl_SI.tsx": "./components/locale-provider/sl_SI.tsx",
	"./locale-provider/sr_RS.tsx": "./components/locale-provider/sr_RS.tsx",
	"./locale-provider/sv_SE.tsx": "./components/locale-provider/sv_SE.tsx",
	"./locale-provider/th_TH.tsx": "./components/locale-provider/th_TH.tsx",
	"./locale-provider/tr_TR.tsx": "./components/locale-provider/tr_TR.tsx",
	"./locale-provider/uk_UA.tsx": "./components/locale-provider/uk_UA.tsx",
	"./locale-provider/vi_VN.tsx": "./components/locale-provider/vi_VN.tsx",
	"./locale-provider/zh_CN.tsx": "./components/locale-provider/zh_CN.tsx",
	"./locale-provider/zh_TW.tsx": "./components/locale-provider/zh_TW.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/locale-provider\\/.+_.+\\.tsx$";